var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table mt-0 table-hover table-sm" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.invoices, function (inv, i) {
          return _c("tr", [
            _c("td", [
              _vm._v(
                _vm._s(
                  i +
                    1 +
                    (_vm.paginator.current_page - 1) * _vm.paginator.per_page
                )
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(inv.id))]),
            _vm._v(" "),
            _c("td", [
              _c("p", [
                _c("span", { class: _vm.getTypeByInvoice(inv, "type", true) }, [
                  _vm._v(_vm._s(_vm.getTypeByInvoice(inv, "type"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.printDate(inv.delivery_date)))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(inv.comment))]),
            _vm._v(" "),
            _c("td", [
              _c("p", [_vm._v(_vm._s(_vm.printDate(inv.created_at)))]),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("p", [
                _vm._v("препаратов: "),
                _c("strong", [_vm._v(_vm._s(+inv.totalDrugs))]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("сумма: "),
                _c("strong", [
                  _vm._v(_vm._s(Math.round(+inv.totalSum * 100) / 100)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("p", [
                _c(
                  "span",
                  { class: _vm.getTypeByInvoice(inv, "status", true) },
                  [_vm._v(_vm._s(_vm.getTypeByInvoice(inv, "status")))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "button",
                {
                  staticClass: "btn btn-xs btn-info",
                  on: {
                    click: function ($event) {
                      return _vm.showInvoice(inv)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Тип")]),
        _vm._v(" "),
        _c("th", [_vm._v("Доставка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Создание")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Статус")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }